<iframe *ngIf="dashboardType === 'SUPERSET'" [src]="selectedUrl" width="100%"
    height="90%"></iframe><!-- this will change in the future if we make that a client can have more than one different endpoint to show-->

<div *ngIf="dashboardType === 'SMART_COFFEE'">
    <app-dashboards-charts></app-dashboards-charts>
</div>